export default {
      id: "ic_close_dark-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_close_dark-usage",
      toString: function () {
        return this.url;
      }
    }